/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * コード変換マスターテーブル（OT_PCUTCDH）のキャッシュ値
 */
export interface CodeTransCacheDto { 
    /**
     * システムコード
     */
    systemCode?: string;
    /**
     * ユーザコード
     */
    userCode?: string;
    /**
     * 表示内容
     */
    displayContent?: string;
    /**
     * 表示内容カナ
     */
    displayContentKana?: string;
    /**
     * 詳細表示内容
     */
    detailedDisplayDetail?: string;
    /**
     * 項目並び順番
     */
    itemOrderOrder?: string;
    /**
     * デフォルトフラグ
     */
    defaultFlag?: string;
}

